import SuperTokens from "supertokens-auth-react";
import Passwordless from "supertokens-auth-react/recipe/passwordless";
import ThirdParty from "supertokens-auth-react/recipe/thirdparty";
import Session from "supertokens-auth-react/recipe/session";

SuperTokens.init({
  appInfo: {
    appName: import.meta.env.VITE_APP_NAME || "joint.photos",
    apiDomain: import.meta.env.VITE_API_DOMAIN || "http://localhost:3000",
    websiteDomain: import.meta.env.VITE_WEBSITE_DOMAIN || "http://localhost:4200",
    apiBasePath: import.meta.env.VITE_API_BASE_PATH || "/api/v1/auth",
    websiteBasePath: import.meta.env.VITE_WEBSITE_BASE_PATH || "/auth",
  },
  recipeList: [
    Passwordless.init({
      contactMethod: "EMAIL",
      onHandleEvent: (event) => {
        if (event.action === "SUCCESS") {
          // Redirect to home page after successful login
          window.location.href = "/";
        }
      },
    }),
    ThirdParty.init({
      signInAndUpFeature: {
        providers: [ThirdParty.Facebook.init(), ThirdParty.Google.init()],
      },
    }),
    Session.init({
      onHandleEvent: () => {},
    }),
  ],
});
